"use client";
import React, { useState, useEffect, useRef } from "react";

export default function StickyHeader({ children }: { children: React.ReactNode }) {
  const [visible,    setVisible]    = useState(true);
  const [onDarkBg,   setOnDarkBg]   = useState(true);
  const lastY = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;

      // hide on scroll down, show on scroll up
      if (y > lastY.current && y > 100) setVisible(false);
      else setVisible(true);
      lastY.current = y;

      // detect background beneath header
      // Banner section (indigo-950) is roughly the first 80vh
      const bannerHeight = window.innerHeight * 0.8;
      setOnDarkBg(y < bannerHeight - 64);
    };

    // initial check
    onScroll();

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-[200] bg-indigo-950 transition-all duration-500
        ${visible ? "translate-y-0" : "-translate-y-full"}
        ${onDarkBg
          ? "border-b border-white/[0.08] shadow-[0_4px_30px_rgba(0,0,0,0.35)]"
          : "border-b border-indigo-950/10 shadow-none"
        }`}
    >
      {/* top accent line */}
      <div className="w-full h-[2px] bg-gradient-to-r from-blue-600 via-indigo-500 to-blue-600" />
      {children}
    </header>
  );
}
